import React from 'react';

import VideoPlayer from '../components/VideoPlayerBitmovin';

export default (props) => (
  <div className="embed">
    <VideoPlayer src={props.src} />
  </div>
);